import { c as _c } from "react/compiler-runtime";
interface LogoProps {
  variant?: 'default' | 'light';
  className?: string;
}
const Logo = t0 => {
  const $ = _c(21);
  const {
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const mainColorClass = variant === "light" ? "fill-white" : "fill-aq-navy";
  const t2 = process.env.NODE_ENV === "test" ? className : `h-10 w-auto transition-colors duration-200 ease-in-out ${className || ""}`;
  const t3 = `${mainColorClass} transition-[fill] duration-200 ease-in-out`;
  let t4;
  if ($[0] !== t3) {
    t4 = <path d="M74.6998 10.5C67.4998 10.5 62.2998 15.7 62.2998 22.9C62.2998 30.1 67.5998 35.2 74.7998 35.2C80.4998 35.2 84.7998 32.2 86.3998 27.1L86.4998 26.8H79.6998V27C78.9998 28.7 77.0998 29.8 74.7998 29.8C71.5998 29.8 69.4998 27.9 68.9998 24.7H86.7998V24.5C87.0998 20.5 85.9998 16.8 83.5998 14.2C81.3998 11.7 78.2998 10.5 74.6998 10.5ZM69.3998 19.7C70.2998 17.3 72.1998 15.9 74.6998 15.9C77.1998 15.9 79.0998 17.3 79.7998 19.7H69.3998Z" className={t3} />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `${mainColorClass} transition-[fill] duration-200 ease-in-out`;
  let t6;
  if ($[2] !== t5) {
    t6 = <path d="M102.8 10.5C99.9002 10.5 97.6002 11.5 95.8002 13.7V11H89.2002V34.7H95.8002V22.3C95.8002 18.6 97.5002 16.8 100.8 16.8C103.7 16.8 104.9 18.1 104.9 21.3V34.8H111.5V19.9C111.4 14.1 108.1 10.5 102.8 10.5Z" className={t5} />;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = `${mainColorClass} transition-[fill] duration-200 ease-in-out`;
  let t8;
  if ($[4] !== t7) {
    t8 = <path d="M138 25.3001H131.3L131.2 25.5001C130.6 27.8001 128.6 29.1001 126 29.1001C124.4 29.1001 123 28.6001 122 27.5001C120.9 26.4001 120.3 24.7001 120.3 22.8001C120.3 20.9001 120.9 19.2001 122 18.1001C123 17.1001 124.4 16.5001 126 16.5001C128.6 16.5001 130.5 17.8001 131.1 20.1001L131.2 20.3001H137.9V20.0001C137 14.3001 132.3 10.4001 126.1 10.4001C119 10.4001 113.7 15.7001 113.7 22.8001C113.7 29.9001 119 35.2001 126 35.2001C131.2 35.2001 136.9 32.2001 137.9 25.6001L138 25.3001Z" className={t7} />;
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const t9 = `${mainColorClass} transition-[fill] duration-200 ease-in-out`;
  let t10;
  if ($[6] !== t9) {
    t10 = <path d="M156.7 11L150.3 23.9L144.1 11.1L144 11H136.2L146.1 31.4L138 46.5H145.8L164.6 11H156.7Z" className={t9} />;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const t11 = `${mainColorClass} transition-[fill] duration-200 ease-in-out`;
  let t12;
  if ($[8] !== t11) {
    t12 = <path d="M60.7996 11.1001H54.4996V12.3001C52.4996 11.0001 50.1996 10.4001 47.7996 10.4001C44.4996 10.4001 41.3996 11.6001 39.1996 13.9001C36.8996 16.2001 35.5996 19.3001 35.5996 22.7001C35.5996 29.7001 40.7996 34.9001 47.7996 34.9001C50.1996 34.9001 52.4996 34.2001 54.4996 33.0001V35.0001C54.4996 38.4001 51.9996 40.8001 48.5996 40.8001C45.8996 40.8001 43.7996 39.3001 42.9996 37.0001V36.9001H36.4996V37.0001C37.4996 42.5001 42.4996 46.4001 48.5996 46.4001C55.5996 46.4001 60.7996 41.5001 60.7996 35.0001V11.1001ZM53.6996 22.6001C53.6996 26.2001 51.1996 28.9001 47.7996 28.9001C44.3996 28.9001 41.8996 26.3001 41.8996 22.6001C41.8996 19.0001 44.3996 16.3001 47.7996 16.3001C51.1996 16.3001 53.6996 19.0001 53.6996 22.6001Z" className={t11} />;
    $[8] = t11;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  const t13 = `${mainColorClass} transition-[fill] duration-200 ease-in-out`;
  let t14;
  if ($[10] !== t13) {
    t14 = <path d="M17.7998 3.80005L3.2998 33.7001H11.3998H20.3998V26.8H14.6998L20.3998 14.8L29.4998 33.7001H37.3998L22.8998 3.80005H17.7998Z" className={t13} />;
    $[10] = t13;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <path d="M180 26.6C175.5 26.6 171.8 22.9 171.8 18.4C171.8 13.9 175.5 10.2 180 10.2C184.5 10.2 188.2 13.9 188.2 18.4C188.2 22.9 184.5 26.6 180 26.6ZM192.9 26.6C194.4 24.2 195.3 21.4 195.3 18.4C195.3 9.99995 188.4 3.19995 180 3.19995C171.5 3.19995 164.7 9.99995 164.7 18.4C164.7 26.7999 171.6 33.5999 180 33.5999C180.3 33.5999 180.6 33.5999 180.9 33.5999H197.3V26.5H192.9V26.6Z" className="fill-aq-orange" />;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] !== t10 || $[14] !== t12 || $[15] !== t14 || $[16] !== t2 || $[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t16 = <svg width="201" height="50" viewBox="0 0 201 50" fill="none" xmlns="http://www.w3.org/2000/svg" className={t2}>{t4}{t6}{t8}{t10}{t12}{t14}{t15}</svg>;
    $[13] = t10;
    $[14] = t12;
    $[15] = t14;
    $[16] = t2;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  return t16;
};
export default Logo;